<mat-select [(value)]="selectedGender" (selectionChange)="selected()">
  <mat-option *ngFor="let gender of Object.values(Gender).reverse()" [value]="gender">
    {{ 'GENDER.' + gender.toUpperCase() | translate }}
  </mat-option>
</mat-select>
